import {Tenant} from '@app/core/models/tenant.model';
import {User} from '@app/core/models/user.model';
import {Department} from '@app/core/models/department.model';

export interface IIntegrationsState {
	isLoading: boolean;
	receivedTenant: Tenant;
	paymentNumberModels: User[] | Department[];
}

export const initialIntegrationsState: IIntegrationsState = {
	isLoading: false,
	receivedTenant: undefined,
	paymentNumberModels: [],
};
